import React from 'react';
import { Enum_LiveStream_Status } from '@core/api';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import { isStreamingLive } from '../../../Player3/components/LiveStreaming/helpers';
import { Badge } from '../Badge';
export const LiveStreamingBadge = ({ liveStreamState, video, }) => {
    const { t } = useTranslation();
    const isLive = liveStreamState
        ? isStreamingLive(liveStreamState)
        : (video === null || video === void 0 ? void 0 : video.live_stream_status) === Enum_LiveStream_Status.ACTIVE ||
            (video === null || video === void 0 ? void 0 : video.live_stream_status) === Enum_LiveStream_Status.PAUSED;
    return isLive ? (<Badge className="cy-live-stream-status" style={{
            background: 'var(--badge-highlight)',
        }}>
      <img width="8" height="8" src={require('@embed/components/common/LiveStreaming/assets/bull.svg')}/>
      <span aria-label={t(`Livestream status: {{status}}`, {
            status: video === null || video === void 0 ? void 0 : video.live_stream_status,
        })}>
        {t('Live')}
      </span>
    </Badge>) : null;
};
